/*!
  Custom js for rior
  Freiheit Media 2023
*/


/** ADD TO CART FUNCTION **/
function addProductVariantToCart(variant_id) {


  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      quantity: 1,
      id: variant_id
    })
  })
  .then(response => response.json())
  .then(data => {
  //  console.log('Produkt erfolgreich zum Warenkorb hinzugefügt:', data);
   // document.dispatchEvent(new CustomEvent('cart:build'));
    var cart = new theme.CartDrawer();
    cart.init();
    cart.open();
    
      updateUpsells();

    

    
      updateUpsells();

    
  })
  .catch(error => {
    console.error('Fehler beim Hinzufügen des Produkts zum Warenkorb:', error);
  });

}



/** STICKY ANNOUNCEMENT BAR **/


document.addEventListener('DOMContentLoaded', function () {
    const announcementBar = document.getElementById('AnnouncementBar');
    const secondAnnouncementBar = document.getElementById('SecondAnnouncementBar');
    const siteHeader = document.getElementById('SiteHeader');

    let previousHeightOfElement1 = 0;
    let previousHeightOfElement2 = 0;

    function debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }

    const adjustMarginTop = debounce(() => {
        const heightOfElement1 = announcementBar?.offsetHeight || 0;
        const heightOfElement2 = secondAnnouncementBar?.offsetHeight || 0;
 
        if (heightOfElement1 !== previousHeightOfElement1 || heightOfElement2 !== previousHeightOfElement2) {
            if (secondAnnouncementBar) {
                secondAnnouncementBar.style.marginTop = `${heightOfElement1}px`;
            }
            
            if (siteHeader) {
                siteHeader.style.marginTop = `${heightOfElement1 + heightOfElement2}px`;
            }

            previousHeightOfElement1 = heightOfElement1;
            previousHeightOfElement2 = heightOfElement2;
        }
    }, 100);

    if (announcementBar || secondAnnouncementBar) {
        const resizeObserver = new ResizeObserver(adjustMarginTop);
        if (announcementBar) resizeObserver.observe(announcementBar);
        if (secondAnnouncementBar) resizeObserver.observe(secondAnnouncementBar);
    }

    // Initial adjustment
    adjustMarginTop();

    // Add margin-top to header-sticky-wrapper if both announcement bars exist
    if (announcementBar && secondAnnouncementBar) {
        const style = document.createElement('style');
        style.innerHTML = '.header-sticky-wrapper { margin-top: 80px; }';
        document.head.appendChild(style);
    }
});

  
  

  


(function () {
  function getCurrentDate() {
    const today = new Date();
    return today.toISOString().split('T')[0];
  }

  function updateQtyForElement(element) {
    const dateId = element.getAttribute("data-id"); 
    const currentDate = getCurrentDate();
    const qtyKey = `currentQty_${dateId}`;
    const dateKey = `lastUpdateDate_${dateId}`;

    const numberElement = element.querySelector(".qty__count-number");
    const initialQty = parseInt(numberElement.textContent.trim(), 10);

    let currentQty = parseInt(localStorage.getItem(qtyKey), 10);
    const lastUpdateDate = localStorage.getItem(dateKey);

    if (isNaN(currentQty)) {
      currentQty = initialQty;
      localStorage.setItem(qtyKey, currentQty);
    }  

    if (lastUpdateDate !== currentDate) {
      currentQty = currentQty > 0 ? currentQty - 1 : initialQty;
      localStorage.setItem(qtyKey, currentQty);
      localStorage.setItem(dateKey, currentDate);
    }

    numberElement.textContent = currentQty;
  }

  function initializeAllQtyCounts() {
    const qtyElements = document.querySelectorAll(".qty__count");
    qtyElements.forEach(updateQtyForElement);
  }

  initializeAllQtyCounts();
})();